<script>
export default {
    props: {
        field: {
            type: Object,
            default: () => {},
        },
    },
    computed: {
        value() {
            if (Array.isArray(this.field.value)) {
                return this.field.value.join('<br>');
            }

            return this.field.value;
        },
    },
};
</script>

<template>
    <div v-html="value" />
</template>

<style
    scoped
    lang="scss"
>

</style>
